import * as t from 'io-ts';

import {parseActivity, RActivity} from './activityModel';
import {makeApiType, RLazyTeammateIdRef} from './apiTypes';
import {parseMessageType, RMessageType} from './messageModel';

/*
 * Runtime type.
 */

export const RNotificationDirty = t.readonly(
  t.type({
    activity: RActivity,
    link: t.string,
    p2FiltersLink: t.string,
    fromName: t.string,
    fromTeammateId: t.union([RLazyTeammateIdRef, t.undefined]),
    summary: t.union([t.undefined, t.string]),
    messageType: t.union([t.undefined, RMessageType]),
  }),
);

/*
 * Types.
 */

export interface NotificationModel extends t.TypeOf<typeof RNotificationDirty> {}
export const RNotification = t.clean<NotificationModel>(RNotificationDirty as any);

/*
 * IO methods.
 */

export function parseNotification(src: any): NotificationModel {
  return {
    activity: parseActivity(src),
    link: src.new_link,
    p2FiltersLink: src.link,
    fromName: (src.from && src.from.display_name) || '',
    fromTeammateId: (src.from && src.from.id) || undefined,
    summary: src.summary || undefined,
    messageType: parseMessageType(src.message_type) || undefined,
  };
}

/*
 * API type.
 */

export const ApiNotification = makeApiType('notification', RNotification, parseNotification);
